import Http from "../strategies/Http";
import Beacon from "../strategies/Beacon";
export default function Hiido(options, initialData) {
  if (Beacon.supported) {
    return new Beacon(options, initialData);
  }

  if (Http.supported) {
    return new Http(options, initialData);
  }
}